/* import __COLOCATED_TEMPLATE__ from './stamped-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

export type StampColor =
  | 'blue'
  | 'sky'
  | 'transparent'
  | 'green'
  | 'gray'
  | 'yellow-light'
  | 'yellow'
  | 'red';

interface Signature {
  Args: {
    item: { text: string };
    componentAttrs: {
      stampText: string;
      stampColor: StampColor;
    };
  };
}

const StampedSelectItem = templateOnlyComponent<Signature>();
export default StampedSelectItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Components::StampedSelectItem': typeof StampedSelectItem;
  }
}
